import { Settelment } from '../../../global/entities/SellOrder';
import { FiscalYear } from '../../../global/entities/BuyOrder';

const NOW_ISO = new Date().toISOString();
export const SELL_ORDER_DEFAULT = {
  dateOffer: NOW_ISO,
  dateAgreement: NOW_ISO,

  company: {
    highestNumberShares: 0,
    highestShareCapital: 0,
    lowestNumberShares: 0,
    lowestShareCapital: 0,
    address: '',
    city: '',
    name: '',
    number: '',
    postalCode: '',
  },
  shareCapital: 0,
  numberShares: 0,

  physicalPeople: [],
  legalShareholders: [],

  commision: false,

  dateDecided: NOW_ISO,
  dateSent: NOW_ISO,
  dateExtraMeetingProtocol: NOW_ISO,

  datePurchased: NOW_ISO,

  fiscalStartDate: NOW_ISO,
  fiscalEndDate: NOW_ISO,

  equity: 0,

  isAnotherBuyer: false,
  purchasePrice: 0,
  representatives: [],
  auditor: {
    auditorOption: 'no',
  } as any,
  acquiredCash: 0,
  banks: [],
  changedFiscalYear: false,
  settelmentType: Settelment.NotDetermined,
  fiscalYear: FiscalYear.JanuaryStart,
  commisionAmount: 0,
  AGAregistered: false,
  VATregistered: false,
  AGAcreatedFrom: NOW_ISO,
  VATcreatedFrom: NOW_ISO,
  dateOfRevocationFTax: NOW_ISO,
  businessManager: { id: '', userId: '' },
  adjuster: { id: '', userId: '' },
  liquidator: { id: '', userId: '' },
  signer: { id: '', userId: '' },
  taxOfficeContactPerson: { id: '', userId: '' },
  shellCompanyDeclaration: {
    id: '',
    sharesInGroupCompaniesAssets: null,
    receivablesFromOtherCompaniesAssets: null,
    cashBankAccountingFundsAssets: null,
    restrictedEquityLiabilities: null,
    unrestrictedEquityLiabilities: null,
    supplierLiabilitiesLiabilities: null,
    liabilitiesToGroupLiabilities: null,
    liabilitiesToOtherCompaniesLiabilities: null,
    taxLiabilitiesLiabilities: null,
    accruedExpensesLiabilities: null,
    netSalesIncomeStatement: null,
    changeOfStockIncomeStatementPositive: null,
    changeOfStockIncomeStatementNegative: null,
    otherOperatingIncomeIncomeStatement: null,
    rawMaterialsIncomeStatement: null,
    otherExternalCostsIncomeStatement: null,
    personnelCostsIncomeStatement: null,
    depreciationOfFixedAssetsIncomeStatement: null,
    otherOperatingCostsIncomeStatement: null,
    resultsFromSharesIncomeStatementPositive: null,
    resultsFromSharesIncomeStatementNegative: null,
    resultsFromFixedAssetsIncomeStatementPositive: null,
    resultsFromFixedAssetsIncomeStatementNegative: null,
    otherInterestIncomeIncomeStatement: null,
    interestCostsIncomeStatement: null,
    reversalOfAccrualFundIncomeStatement: null,
    reversalOfExcessDepreciationStatementPositive: null,
    reversalOfExcessDepreciationStatementNegative: null,
    taxOnYearsProfitIncomeStatement: null,
    profitIncomeStatement: null,
    lossIncomeStatement: null,
    profitTaxAdjustments: null,
    lossTaxAdjustments: null,
    taxOnYearsProfitTaxAdjustments: null,
    impairmentOfAssetsTaxAdjustments: null,
    otherRecordedCostsTaxAdjustments: null,
    pieceProfitsTaxAdjustments: null,
    dividendTaxAdjustments: null,
    otherRecordedIncomeTaxAdjustments: null,
    revaluedReversalAccrualFundTaxAdjustments: null,
    coOwnershipDisposalRecordedProfit: null,
    coOwnershipDisposalRecordedLoss: null,
    unusedDeficitPrevYearTaxAdjustments: null,
    reductionOfUnusedDeficitTaxAdjustments: null,
    surplusTaxAdjustments: null,
    deficitTaxAdjustments: null,
  },
  auditorReservation: false,
  // Project 7: "Extern firmatecknare" Nej/Ja switch defaults to Ja (true) for new orders.
  externalSignatoriesEnabled: true,
};
